import { LuCalendar, LuLayoutDashboard, LuListChecks, LuPackage, LuSticker, LuStickyNote, LuView } from "react-icons/lu";
import { APP_URLS } from "../../config";
import { COMMON_MENU } from "./common/common";

export const CUSTOMER_SERVICE_MENU = [
    ...COMMON_MENU,
    {
        title: "Manage Prospects",
        icon: LuStickyNote,
        path: APP_URLS.PROSPECTS.ROUTES,
        hasSubMenu: false
    },
    {
        title: 'Manage Sales',
        icon: LuSticker,
        hasSubMenu: true,
        submenu: [
            {
                title: 'All Applications',
                path: APP_URLS.APPLICATION.ROUTE,
                icon: LuView
            },
            // {
            //     title: 'View Reports',
            //     path: APP_URLS.LEADS.REPORTS,
            //     icon: LuPackage
            // }
        ]
    }
]